import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
export function toSchema(schema) {
    checkDefined(schema.studyDesignId, 'schema', 'studyDesignId');
    return {
        ...toBaseStudyEntity(schema, StudyEntityType.Schema),
        studyDesignId: schema.studyDesignId,
    };
}
//# sourceMappingURL=schema.js.map